export enum SdgScreen {
  What,
  Why,
  Overview,
}
